const selectAlertMessage = (state) => {
    return {
        ...state.alert
    };
}

export {
    selectAlertMessage
}